import { action, observable } from 'mobx';

export class UI {
	@observable promotions = [];
	@observable categories = [];

	@observable selectedPromotion = {};

	@action
	savePromotion(promotion) {
		this.promotions.push(promotion);
	}

	@action
	saveCategory(category) {
		this.categories.push(category);
	}

	@action
	setSelectedPromotion(promotion) {
		this.collapseOtherPromotions(promotion.promo_id);
		this.selectedPromotion = promotion;
	}

	@action
	resetPromotionState() {
		this.promotions = [];
		this.categories = [];
	}

	collapseOtherPromotions(promotionId) {
		this.deselectPromotionInMenu();
		this.collapsePromotions(promotionId);
		window.scrollTo(0, 0);
	}

	@action
	deselectPromotionInMenu(categoryId) {
		if (categoryId) {
			const [category] = this.categories.filter(
				category => category.id === categoryId
			);
			if (category) {
				category.select(false);
			}
		} else {
			this.categories.map(category => {
				category.select(false);
			});
		}
	}

	collapsePromotions(selectedPromotion) {
		this.promotions.forEach(promotion => {
			if (promotion.id !== selectedPromotion) {
				promotion.expand(false);
			}
		});
	}
}

export default new UI();



// WEBPACK FOOTER //
// ./src/state/UI.js